import React from 'react'
import '../styles/ErrorPage.css'
import { Link } from 'react-router-dom'
export default function ErrorPage() {
  return (
    <div className='Error'>
      <h1>404 :(</h1>
      <h2>This page doesn't exist</h2>
      <Link to='/'>Go back</Link>
    </div>
  )
}
